<script>
    import { getContext } from 'svelte';

    // --- Properties
    export let dataKey;
    const { 
        orderCar: order, activeCar: active, cars, 
        hoverCar, unhoverCar, toggleCarSelection
    } = getContext(dataKey); 
</script>

<div id="cars">
    <div class='header no-select'>
        <span>Cars</span>
    </div>
    <div class='labels'>
        <span class='num'>id</span>
        <span class='tr'>#</span>
    </div>
    {#each $order as car}
        {#if car in $cars}
            <div class='car'
                class:fade={!$active[car]}
                on:mouseenter={() => hoverCar($cars[car])}
                on:mouseleave={() => unhoverCar($cars[car])}
                on:click={() => toggleCarSelection($cars[car])}>
                <span class='num'>{car} </span>
                <span class='tr'>{$cars[car].num_transaction_stops}</span>
            </div>
        {/if}
    {/each}
</div>


<style>
#cars {
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    flex-direction: column;
    margin-left: 5px;
    margin-right: 80px;
}

#cars div {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    flex-shrink: 0;
    flex-grow: 0;
}

.header {
    height: 20px;
}

.header span {
    line-height: 20px;
    display: block;
    width: 55px;
    text-align: center;
}

.labels { 
    height: 40px;
    font-size: 15px;
}

.labels span {
    display: block;
    text-align: left;
    line-height: 15px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.car {
    height: 10px;
    font-size: 12px;
    text-align: right;
    cursor: pointer;    
}

.car.fade {
    opacity: 0.5;
}

.car * {
    display: block;
    line-height: 10px;
    text-align: right;
}

.num {
    width: 25px;
    font-size: 14px;
}

.tr {
    width: 30px;
    font-size: 14px;
}

</style>